// @flow
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from '@finect/tabular-components/Tooltip';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Bookmark } from '@finect/tabular-icons/bookmark';
import { Heart } from '@finect/tabular-icons/heart';
import { CornerUpLeft } from '@finect/tabular-icons/cornerUpLeft';
import { Share as ShareIcon } from '@finect/tabular-icons/share';
import { CheckCircle } from '@finect/tabular-icons/checkCircle';
import { Mail } from '@finect/tabular-icons/mail';
import { Share } from '@finect/tabular-components/Share';
import { INDEX_QUESTIONS } from '@finect/tabular-components/Questions';
import { Action } from './Action';
import { Count } from './Count';

type Props = {
  like?: {
    qty: number,
    action: Function,
    done: boolean,
    disable?: string
  },
  save?: {
    action: Function,
    done: boolean
  },
  respond?: {
    qty: number,
    id?: string | number,
    solved?: string,
    path?: string,
    action?: Function,
    disable?: string
  },
  select?: {
    action: Function,
    done: boolean,
    disable?: string
  },
  share?: {
    title: string,
    path: string
  },
  adviser?: {
    id: string,
    name: string
  }
};

const ToolbarItems = ({ like, save, respond, share, select, adviser }: Props) => {
  let respondProps = {};
  if (respond && !respond.disable) {
    respondProps = respond.action
      ? { onClick: respond.action }
      : {
        as: Link,
        to: {
          pathname: respond.path || '',
          hash: respond.solved ? `respuesta-${respond.solved}` : '',
          state: { fromApp: true }
        },
        rel: respond.id && !INDEX_QUESTIONS.includes(Number(respond.id)) ? 'nofollow' : undefined
      };
  }

  return (
    <Fragment>
      {select ? (
        <Action
          color="success"
          done={select.done}
          maxScale={1.05}
          fill="none"
          onClick={!select.disable ? select.action : null}
        >
          <CheckCircle />
          <span>Mejor respuesta</span>
        </Action>
      ) : null}
      {like ? (
        <Tooltip disabled={!like.disable} from="left" display="block" width="180px" tip={like.disable}>
          <Action
            color="secondary"
            done={like.done}
            onClick={!like.disable ? like.action : null}
            disabled={Boolean(like.disable)}
          >
            <Count>{like.qty || 0}</Count>
            <Heart />
            <span>Me gusta</span>
          </Action>
        </Tooltip>
      ) : null}
      {respond ? (
        <Tooltip disabled={!respond.disable} from="left" display="block" width="180px" tip={respond.disable}>
          <Action color="primary" solved={respond.solved} {...respondProps} disabled={Boolean(respond.disable)}>
            <Count solved={respond.solved}>{respond.qty || 0}</Count>
            <CornerUpLeft style={{ position: 'relative', top: '-1px' }} />
            <span>Responder</span>
          </Action>
        </Tooltip>
      ) : null}
      {save ? (
        <Action done={save.done} maxScale={1.05} onClick={save.action}>
          <Bookmark />
          <span>{save.done ? 'Guardado' : 'Guardar'}</span>
        </Action>
      ) : null}
      {share ? (
        <Share
          title={share.title}
          url={`https://${process.env.FINECT_BASEURL || 'www.finect.com'}${share.path}`}
          via="Finect"
          arrowPosition={3}
          positionX="top"
        >
          <Action>
            <ShareIcon />
            <span>Compartir</span>
          </Action>
        </Share>
      ) : null}
      {adviser ? (
        <Action style={{ marginLeft: '24px' }} highlighted>
          <Mail />
          <AppLink
            href={`https://${process.env.FINECT_BASEURL || 'www.finect.com'}/mensajes/nuevo?members=${adviser.id}`}
            rel="nofollow"
          >
            <span>Escribe a {adviser.name}</span>
          </AppLink>
        </Action>
      ) : null}
    </Fragment>
  );
};

export default ToolbarItems;
